function parseMs(ms: number) {
  return {
    days: Math.trunc(ms / 86400000),
    hours: Math.trunc(ms / 3600000) % 24,
    minutes: Math.trunc(ms / 60000) % 60,
    seconds: Math.trunc(ms / 1000) % 60,
    ms: Math.trunc(ms) % 1000,
  };
}

function addZero(value: number, digits: number = 2): string {
  let str = value.toString();
  const size = digits - str.length + 1;

  str = new Array(size).join('0').concat(str);

  return str;
}

function getSign(duration: number): string {
  return duration <= -1000 ? '-' : '';
}

export default function formatDuration(duration: number): string {
  const ms = duration * 1000;
  const unsignedMs = ms < 0 ? -ms : ms;
  const sign = getSign(ms);
  const t = parseMs(unsignedMs);
  const seconds = addZero(t.seconds);
  let output = '';

  if (t.days && !output) {
    output = `${sign + t.days}:${addZero(t.hours)}:${addZero(t.minutes)}:${seconds}`;
  }

  if (t.hours && !output) {
    output = `${sign + t.hours}:${addZero(t.minutes)}:${seconds}`;
  }

  if (!output) {
    output = `${sign + t.minutes}:${seconds}`;
  }

  return output;
}
